module.exports = __webpack_public_path__ + "static/media/Eventy_A.9cc978d3.png";